import { BaseNavigationItemBuilder } from '@/agent/entities/navigation/BaseNavigationItemBuilder'
import { type NavAction, type NavItem, type NavItemContext } from '@/common/types/navigation'
import { type IModuleContext } from '@/common/types/module'

export class CalendarNavigationItemBuilder extends BaseNavigationItemBuilder {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(context: IModuleContext, action: NavAction<any>) {
    super(context, action)
    this.textKey = 'assist.action.calendar'
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  *buildNavigationItem(action: NavAction<any>, itemContext: NavItemContext): IterableIterator<NavItem> {
    const skillId = action.actionData?.skillId
    if (skillId) {
      yield {
        ...this.getDefaultNavigationItem(action, itemContext),
        target: `/assist/calendar/show/${action.actionData.skillId}`,
      } as NavItem
    }
  }
}
